/* Fernbedienung / USB-Dimmer zum Ausprobieren (lllr) */
(function(){
  var C=[147,305,465,622];
  var KEYS={
    '12v':{w:762,h:1620,size:16,keys:(function(){
      var k=[['on',378,175,'ON'],['off',378,330,'OFF'],['up',378,465,'aBright'],['down',378,780,'aDim'],
             ['sm',222,625,'Speed −'],['light',380,628,'Light'],['sp',540,625,'Speed +'],
             ['mm',147,928,'Mode −'],['mp',305,928,'Mode +']];
      for(var p=10;p<=100;p+=10){var n=p/10+1;k.push(['p'+p,C[n%4],928+152*Math.floor(n/4),p+' %'])}
      [5,10,30,60].forEach(function(t,i){k.push(['t'+t,C[i],1385,['aTimer',t]])});
      return k})(),
      marks:[[1,330,128,['on','off']],[2,328,418,['up','down']],[3,334,584,['light']],[4,176,580,['sm','sp']],[5,100,880,['mm','mp']],
             [6,418,880,['p10','p20','p30','p40','p50','p60','p70','p80','p90','p100']],[7,100,1338,['t5','t10','t30','t60']]]},
    'usb-hoch':{w:340,h:1470,size:44,ms:28,keys:[['plus',172,494,'aBright'],['pow',172,703,'aPow'],['minus',172,916,'aDim']],marks:[[1,112,862,['minus']],[2,112,650,['pow']],[3,112,440,['plus']]]},
    'usb-quer':{w:1470,h:340,size:10.5,ms:6.5,keys:[['plus',976,172,'aBright'],['pow',767,172,'aPow'],['minus',554,172,'aDim']],marks:[[1,500,62,["minus"]],[2,713,62,["pow"]],[3,922,62,["plus"]]]}
  };
  // Deutsche Texte; andere Sprachen kommen aus assets/lllr-i18n-<locale>.js (window.LLLR_T)
  var DE={title:'Probier es <em>selbst aus</em>',intro:'Tipp auf die Knöpfe und sieh, was dein Schild kann.',tab12:'12V mit Fernbedienung',tabusb:'USB mit Dimmer',
    start12:'Drück auf ON, um dein Schild einzuschalten.',startusb:'Drück die mittlere Taste, um dein Schild einzuschalten.',
    hint12:'Pfeile gedrückt halten: stufenlos heller oder dunkler',hintusb:'9 Stufen, der Dimmer merkt sich deine letzte Einstellung',
    off:'AUS',step:'Stufe {n} / 9',mode:'Modus',tempo:'Tempo',modes:['Dauerlicht','Blinken','Atmen','Stroboskop','Doppel-Blitz'],
    usbOn:'Eingeschaltet, mit der zuletzt gewählten Stufe {n}.',usbOff:'Ausgeschaltet. Der Dimmer merkt sich deine Stufe.',usbNeed:'Erst die mittlere Taste drücken, dann reagiert das Schild.',
    usbMax:'Stufe 9: volle Helligkeit.',usbMin:'Stufe 1: die dunkelste Stufe.',up:'Eine Stufe heller.',down:'Eine Stufe dunkler.',
    need:'Erst ON drücken, dann reagiert das Schild.',on:'Eingeschaltet. Probier die Prozent-Tasten oder MODE.',offMsg:'Ausgeschaltet.',
    light:'LIGHT: Blinken aus, das Schild leuchtet dauerhaft.',effect:'Effekt: {m}. Mit SPEED machst du ihn schneller oder langsamer.',
    speedNeed:'SPEED wirkt auf die Blinkeffekte. Drück erst MODE.',speed:'Tempo {n} von 10.',pct:'Helligkeit direkt auf {n} %.',
    timer:'Timer: Das Schild schaltet sich in {n} Minuten von selbst aus.',timerEnd:'Timer abgelaufen: Das Schild hat sich von selbst ausgeschaltet.',
    holdUp:'Gedrückt halten: immer heller.',holdDown:'Gedrückt halten: immer dunkler.',
    aBright:'Heller',aDim:'Dunkler',aPow:'An / Aus',aTimer:'Timer {n} Min',altRemote:'Fernbedienung für 12V-Neonschilder',altDimmer:'USB-Dimmer am Kabel',
    info:'ⓘ Alle Knöpfe erklärt',infoClose:'← Zurück zum Schild',legTitle:'Das kann deine Fernbedienung',legTitleUsb:'Das kann dein USB-Dimmer',
    leg12:[['ON / OFF','Schaltet dein Schild ein und aus.'],['☀ ▲ / ☀ ▼','Heller oder dunkler. Kurz drücken: eine Stufe. Gedrückt halten: stufenlos.'],
      ['LIGHT','Beendet das Blinken, das Schild leuchtet dauerhaft.'],['SPEED − / +','Macht den Blinkeffekt langsamer oder schneller, in 10 Stufen.'],
      ['MODE − / +','Schaltet durch die voreingestellten Blinkeffekte.'],['10 % – 100 %','Wählt eine der 10 Helligkeitsstufen direkt.'],
      ['Timer 5 · 10 · 30 · 60','Schaltet das Schild nach 5, 10, 30 oder 60 Minuten von selbst aus.']],
    legUsb:[['−','Eine Stufe dunkler.'],['⏻','An und aus. Beim Einschalten startet die zuletzt gewählte Stufe.'],['+','Eine Stufe heller, bis zur vollen Helligkeit auf Stufe 9.']]};
  function T(k,v){var L=window.LLLR_T||{},s=L[k]!=null?L[k]:DE[k];if(v)for(var x in v)s=s.split('{'+x+'}').join(v[x]);return s}
  var MODES=T('modes');

  function pane(el){
    var kind=el.dataset.kind, steps=kind==='usb'?9:10;
    var stage=el.querySelector('.lllr__stage'), badge=el.querySelector('.lllr__badge'), timerEl=el.querySelector('.lllr__timer'),
        statusEl=el.querySelector('.lllr__status'), msg=el.querySelector('.lllr__msg'), irs=el.querySelectorAll('.lllr__ir');
    // 11 Stufen (0 %, 10 % … 100 %) liegen untereinander in einem Bild
    var sprite=stage.dataset.sprite, layers=[], loaded=false;
    function load(){
      if(loaded) return; loaded=true;
      for(var i=0;i<=10;i++){
        var d=document.createElement('div');d.className='lllr__frame';
        d.style.backgroundImage='url('+sprite+')';d.style.backgroundPosition='0 '+(i*10)+'%';
        stage.insertBefore(d,timerEl);layers.push(d);
      }
    }
    function draw(b){
      if(!layers.length) return;
      b=Math.max(0,Math.min(100,b));
      var k=Math.min(9,Math.floor(b/10)),f=b/10-k;
      for(var j=1;j<=10;j++) layers[j].style.opacity=j<=k?1:(j===k+1?f:0);
    }
    var S={on:false,level:100,step:steps,mode:0,speed:5,timerEnd:0}, t0=performance.now(), last=-1;
    function out(now){
      if(!S.on) return 0;
      var L=S.level,f=.35*Math.pow(1.25,S.speed-1),t=(now-t0)/1000*f;
      switch(S.mode){
        case 1:return (t%1)<.5?L:0;
        case 2:return L*(.08+.92*(.5-.5*Math.cos(t*Math.PI)));
        case 3:return (t*4%1)<.25?L:0;
        case 4:var x=t%2;return x<.15||(x>.3&&x<.45)?L:L*.15;
        default:return L;
      }
    }
    function say(t){msg.textContent=t}
    function ui(){
      badge.textContent=!S.on?T('off'):(kind==='usb'?T('step',{n:S.step}):Math.round(S.level)+' %');
      timerEl.style.display=S.timerEnd&&S.on?'block':'none';
      statusEl.innerHTML=S.on&&kind!=='usb'?'<span>'+T('mode')+': <b>'+MODES[S.mode]+'</b></span>'+(S.mode?'<span>'+T('tempo')+': <b>'+S.speed+' / 10</b></span>':''):'';
    }
    function setLevel(v){S.level=Math.max(10,Math.min(100,v))}
    function press(id,quiet){
      if(kind==='usb'){
        if(id==='pow'){S.on=!S.on;say(S.on?T('usbOn',{n:S.step}):T('usbOff'))}
        else if(!S.on){say(T('usbNeed'));return}
        else{
          S.step=Math.max(1,Math.min(9,S.step+(id==='plus'?1:-1)));
          say(S.step===9&&id==='plus'?T('usbMax'):S.step===1&&id==='minus'?T('usbMin'):T(id==='plus'?'up':'down'));
        }
        S.level=S.step/9*100; ui(); return;
      }
      if(id!=='on'&&id!=='off'&&!S.on){say(T('need'));return}
      switch(id){
        case 'on':S.on=true;say(T('on'));break;
        case 'off':S.on=false;S.timerEnd=0;say(T('offMsg'));break;
        case 'up':setLevel(Math.floor(S.level/10)*10+10);if(!quiet)say(T('up'));break;
        case 'down':setLevel(Math.ceil(S.level/10)*10-10);if(!quiet)say(T('down'));break;
        case 'light':S.mode=0;say(T('light'));break;
        case 'mp':S.mode=S.mode%(MODES.length-1)+1;say(T('effect',{m:MODES[S.mode]}));break;
        case 'mm':S.mode=S.mode<=1?MODES.length-1:S.mode-1;say(T('effect',{m:MODES[S.mode]}));break;
        case 'sp':case 'sm':
          if(!S.mode){say(T('speedNeed'));break}
          S.speed=Math.max(1,Math.min(10,S.speed+(id==='sp'?1:-1)));say(T('speed',{n:S.speed}));break;
        default:
          if(id[0]==='p'){setLevel(+id.slice(1));say(T('pct',{n:id.slice(1)}))}
          if(id[0]==='t'){var m=+id.slice(1);S.timerEnd=Date.now()+m*60000;say(T('timer',{n:m}))}
      }
      ui();
    }
    function blink(){irs.forEach(function(i){i.classList.add('on')});setTimeout(function(){irs.forEach(function(i){i.classList.remove('on')})},150)}
    el.querySelectorAll('.lllr__remote').forEach(function(r){
      var cfg=KEYS[r.dataset.layout];
      cfg.keys.forEach(function(k){
        var b=document.createElement('button');b.type='button';b.dataset.id=k[0];b.setAttribute('aria-label',Array.isArray(k[3])?T(k[3][0],{n:k[3][1]}):(DE[k[3]]?T(k[3]):k[3]));
        b.style.left=(k[1]/cfg.w*100)+'%';b.style.top=(k[2]/cfg.h*100)+'%';b.style.width=cfg.size+'%';
        r.appendChild(b);
        function flash(){b.classList.remove('hit');void b.offsetWidth;b.classList.add('hit');blink()}
        if(k[0]==='up'||k[0]==='down'){
          // kurz drücken = eine Stufe, gedrückt halten = stufenlos weiter
          var hold=null,rep=null;
          b.addEventListener('pointerdown',function(e){
            e.preventDefault();flash();var dir=k[0]==='up'?1:-1;
            hold=setTimeout(function(){
              if(!S.on){press(k[0]);return}
              say(T(dir>0?'holdUp':'holdDown'));
              rep=setInterval(function(){setLevel(S.level+dir*1.5);ui()},60);
            },350);
          });
          var end=function(){
            if(hold===null)return;
            if(rep===null)press(k[0]);
            clearTimeout(hold);clearInterval(rep);hold=rep=null;
          };
          ['pointerup','pointerleave','pointercancel'].forEach(function(ev){b.addEventListener(ev,end)});
          b.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();flash();press(k[0])}});
        }else{
          b.addEventListener('click',function(){flash();press(k[0])});
        }
      });
    });
    // Erklärung: nummerierte Punkte auf der Fernbedienung und eine Liste statt des Schilds
    el.querySelectorAll('.lllr__remote').forEach(function(r){
      var cfg=KEYS[r.dataset.layout];
      cfg.marks.forEach(function(m){
        var s=document.createElement('span');s.className='lllr__num';s.textContent=m[0];
        s.style.left=(m[1]/cfg.w*100)+'%';s.style.top=(m[2]/cfg.h*100)+'%';s.style.width=(cfg.ms||9)+'%';
        r.appendChild(s);
      });
    });
    var leg=document.createElement('div');leg.className='lllr__legend';
    var items=T(kind==='usb'?'legUsb':'leg12'), groups=KEYS[kind==='usb'?'usb-hoch':'12v'].marks;
    leg.innerHTML='<h4>'+T(kind==='usb'?'legTitleUsb':'legTitle')+'</h4><ol>'+items.map(function(it,i){
      return '<li><button type="button" data-g="'+i+'"><span class="lllr__num">'+(i+1)+'</span><b>'+it[0]+'</b><span>'+it[1]+'</span></button></li>'}).join('')+'</ol>';
    stage.parentNode.insertBefore(leg,stage.nextSibling);
    leg.querySelectorAll('button').forEach(function(x){x.addEventListener('click',function(){
      groups[+x.dataset.g][3].forEach(function(id){el.querySelectorAll('.lllr__remote button[data-id="'+id+'"]').forEach(function(b){
        b.classList.remove('hit');void b.offsetWidth;b.classList.add('hit')})});
    })});
    var tg=document.createElement('button');tg.type='button';tg.className='lllr__info';tg.textContent=T('info');
    el.querySelector('.lllr__right').appendChild(tg);
    tg.addEventListener('click',function(){
      var on=el.classList.toggle('is-info');tg.textContent=T(on?'infoClose':'info');
      if(on&&window.innerWidth<750)leg.scrollIntoView({behavior:'smooth',block:'start'});
    });
    function loop(now){
      var v=out(now); if(v!==last){draw(v);last=v}
      if(S.timerEnd){
        var s=Math.max(0,Math.ceil((S.timerEnd-Date.now())/1000));
        timerEl.textContent='⏱ '+Math.floor(s/60)+':'+String(s%60).padStart(2,'0');
        if(!s){S.timerEnd=0;S.on=false;say(T('timerEnd'));ui()}
      }
      requestAnimationFrame(loop);
    }
    ui();
    return {start:function(){load();last=-1;requestAnimationFrame(loop)}};
  }

  function init(root){
    if(root.dataset.ready)return; root.dataset.ready=1;
    // Deutsch kommt aus dem Theme-Editor; nur andere Sprachen überschreiben die Texte
    if(window.LLLR_T)root.querySelectorAll('[data-t]').forEach(function(e){var v=T(e.dataset.t);if(e.dataset.t==='title')e.innerHTML=v;else e.textContent=v});
    if(window.LLLR_T)root.querySelectorAll('[data-talt]').forEach(function(e){e.alt=T(e.dataset.talt)});
    var panes=[].map.call(root.querySelectorAll('.lllr__pane'),pane), started=false;
    var io=new IntersectionObserver(function(e){
      if(!e[0].isIntersecting||started)return; started=true; io.disconnect();
      panes.forEach(function(p){p.start()});
    },{rootMargin:'300px'});
    io.observe(root);
    var tabs=root.querySelectorAll('.lllr__tabs button');
    tabs.forEach(function(t,i){t.addEventListener('click',function(){
      tabs.forEach(function(x,j){x.classList.toggle('is-on',i===j)});
      root.querySelectorAll('.lllr__pane').forEach(function(p,j){p.hidden=i!==j});
    })});
  }
  function all(){document.querySelectorAll('.lllr').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
  document.addEventListener('shopify:section:load',all);
})();
